import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { Appointment } from "../../models/appointment.model";

export class AppointmentsHelper {
    private dialog: DialogUtils;
    public activeUser: User;
    public permissionProvider: PermissionCheck;

    constructor(
        $cookies: any,
        DialogUtils: DialogUtils,
        PermissionCheck: PermissionCheck,
        UserDataProvider: UserDataProvider
    ) {
        this.dialog = DialogUtils;
        UserDataProvider.getUser($cookies.get("uid")).then((user: User) => {
            this.activeUser = user;
        });
        this.permissionProvider = PermissionCheck;
    }

    hasPermissionToChange(
        appointment: Appointment,
        feature: string = "all"
    ): boolean {
        if (!appointment.id || (this.activeUser && this.activeUser.isAdmin())) {
            return true;
        }
        if (feature == "all") {
            return (
                this.permissionProvider.hasPermission("EDIT_APPOINTMENTS") ||
                this.permissionProvider.hasPermission("DELETE_APPOINTMENTS") ||
                this.permissionProvider.hasPermission("CANVASSER") ||
                (appointment.uid && this.activeUser.uid == appointment.uid)
            );
        } else {
            return (
                this.permissionProvider.hasPermission(feature) ||
                this.permissionProvider.hasPermission("CANVASSER") ||
                (appointment.uid && this.activeUser.uid == appointment.uid)
            );
        }
    }
}

angular.module("planner").service("AppointmentsHelper", AppointmentsHelper);
